import { useStatsigClient } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Custom hook to check if WhatsApp compliance is enabled.
 *
 * Returns `true` if either the local feature flag ("enable-whatsapp-compliance")
 * or the Statsig feature gate ("enable_whatsapp_compliance") is enabled.
 * This allows for enabling the feature via either mechanism.
 */
export const useWhatsappCompliance = (): boolean => {
  const featureFlag = useFeatureFlag("enable-whatsapp-compliance");

  const statsigClient = useStatsigClient();
  const featureGate = statsigClient.checkGate("enable_whatsapp_compliance");

  return featureFlag || featureGate;
};
